<aside class="sidebar" [class.sidebar--collapsed]="collapsed">
  <div class="sidebar-header">
    <div class="sidebar-logo-icon">
      <i class="fal fa-truck"></i>
    </div>
    <h1 class="sidebar-title">{{ titreSidebar }}</h1>
    <p class="sidebar-subtitle">{{ sousTitreSidebar }}</p>
    <div *ngIf="roleUtilisateur" class="role-badge">
      <span class="role-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
      </span>
      <span class="role-label">{{ obtenirLibelleRole() }}</span>
    </div>
  </div>

  <nav class="sidebar-nav">
    <ng-container *ngFor="let element of elementsMenu">

      <!-- ── Séparateur de section ── -->
      <div *ngIf="element.divider" class="nav-section-divider">
        <span class="nav-section-label">{{ element.sectionLabel }}</span>
      </div>

      <!-- ── Élément avec sous-menu ── -->
      <ng-container *ngIf="!element.divider && aSousMenu(element); else navSimple">
        <!-- Déclencheur du groupe -->
        <button
          class="nav-item nav-item--group"
          [class.nav-item--group-open]="sousMenuOuvert === element.idMenu"
          (click)="toggleSousMenu(element.idMenu)"
          [attr.title]="collapsed ? element.libelle : null"
          type="button">
          <span class="nav-icon"><i [class]="element.icone"></i></span>
          <span class="nav-label">{{ element.libelle }}</span>
          <span class="nav-chevron">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" width="14" height="14">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </span>
        </button>

        <!-- Sous-menu animé -->
        <div class="nav-submenu" [class.nav-submenu--open]="sousMenuOuvert === element.idMenu">
          <a
            *ngFor="let enfant of element.enfants"
            [routerLink]="enfant.route"
            [queryParams]="enfant.queryParams"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            class="nav-subitem"
            [attr.title]="collapsed ? enfant.libelle : null">
            <span class="nav-subitem-dot"></span>
            <span class="nav-icon nav-icon--sub"><i [class]="enfant.icone"></i></span>
            <span class="nav-label">{{ enfant.libelle }}</span>
          </a>
        </div>
      </ng-container>

      <!-- ── Élément simple ── -->
      <ng-template #navSimple>
        <ng-container *ngIf="!element.divider">
          <a
            [routerLink]="element.route"
            [queryParams]="element.queryParams"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            class="nav-item"
            [attr.title]="collapsed ? element.libelle : null">
            <span class="nav-icon"><i [class]="element.icone"></i></span>
            <span class="nav-label">{{ element.libelle }}</span>
          </a>
        </ng-container>
      </ng-template>

    </ng-container>
  </nav>
</aside>
